import React from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export const CustomSelect = ({
    updateValue,
    itemsToShow,
    customClass = '',
    defaultItem,
}: {
    updateValue: (e: string) => void;
    itemsToShow: string[] | number[];
    customClass?: string;
    defaultItem?: string;
}) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });

    const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        updateValue(e.target.value);
    };
    const translatedItems =
        typeof itemsToShow[0] == 'string' ? itemsToShow.map((item) => t(String(item))) : itemsToShow;

    return (
        <Form.Select
            aria-label='Default select example'
            defaultValue={defaultItem ? defaultItem : itemsToShow[0]}
            className={`w-50 ${customClass}`}
            onChange={(e) => handleSelect(e)}
        >
            {translatedItems.map((item, index) => (
                <option key={index} value={itemsToShow.at(index)}>
                    {item}
                </option>
            ))}
        </Form.Select>
    );
};
